export const iconFontAwesomeEducationMusic = (
	<i className="fa-solid fa-music"></i>
);
